import React from 'react';
import { Footer } from '@/components/base/Footer';
import { MainAppBarDrawer, MainAppBarDrawerProps } from '@/components/base/MainAppBarDrawer';
import { StandardHeader } from '@/components/base/header/Header';
import { PageHead } from '@/components/base/PageHead';
import { Box } from '@mui/system';
import { ToolbarPadder } from '@/components/base/ToolbarPadder';

type MainLayoutProps = {
  title?: string;
} & MainAppBarDrawerProps;

export const MainLayout: React.FC<MainLayoutProps> = ({
  title,
  showSearchBar,
  value,
  onChange,
  placeholder,
  onToggleDrawer,
  anchor,
  drawerWidth,
  drawerWidthWhenPermanent,
  children,
}) => {
  return (
    <>
      <PageHead title={title} />
      {/* <MainAppBarDrawer
        showSearchBar={showSearchBar}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onToggleDrawer={onToggleDrawer}
        anchor={anchor}
        drawerWidth={drawerWidth}
        drawerWidthWhenPermanent={drawerWidthWhenPermanent}
      /> */}
      <StandardHeader />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <ToolbarPadder />
        {children}
      </Box>
      <Footer />
    </>
  );
};
